import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const dhlRed = {
  100: '#FBE6E7',
  200: '#F6CDCF',
  300: '#EE9BA0',
  400: '#E56970',
  500: '#DD3741',
  600: '#D40511',
  700: '#AA040E',
  800: '#7F030A',
  900: '#550207',
} satisfies Partial<Color>
